<template>
    <ul class="cs_tabMenu">
        <li
            v-for="tab in tabs"
            :class="tab.idx === activeMenu ? 'active' : ''"
            @click="toPage(tab)"
        >{{ tab.name }}</li>
    </ul>
</template>

<script>

export default {
    data() {
        return {
            tabs: [
                { idx: 1, name: '공지사항', pageName: 'NoticeListPage', starter: '/customer-service/notice' },
                { idx: 2, name: '자주 묻는 질문', pageName: 'FaqListPage', starter: '/customer-service/faq' },
                { idx: 3, name: '1:1 문의', pageName: 'InquiryCreatePage', starter: '/customer-service/inquiry' },
                { idx: 4, name: '이용약관', pageName: 'TermsOfUsePage', starter: '/customer-service/terms' },
                { idx: 5, name: '개인정보처리방침', pageName: 'PrivacyPolicyPage', starter: '/customer-service/privacy' },
            ],
            activeMenu: 0
        }
    },

    methods: {
        toPage(tab) {
            if (tab.idx !== this.activeMenu) {
                this.$router.push({ name: tab.pageName})
            }
        },

        updateActiveMenu(currentPath) {
			for (const tab of this.tabs) {
			    const match = currentPath.startsWith(tab.starter);
                if (match) {
                    this.activeMenu = tab.idx
                    return;
                }
			}
			this.activeSubMenu = 0;
		},
    },

    watch: {
		$route(newRoute) {
			this.updateActiveMenu(newRoute.path);
		},
	},

	mounted() {
		this.updateActiveMenu(this.$route.path)
	}
    
}
</script>
<style lang="">
    
</style>
